import { Link } from 'react-router-dom';
import { useLang } from '../i18n/context';
import { readingMinutes } from '../lib/api';
import { DEFAULT_KOLUM_COVER } from '../lib/site';
import { onImgError } from '../../lib/images';

export default function ArticleCard({ article, featured = false }) {
    const { lang, t } = useLang();
    const href = `/dental/${lang}/kolum/${article.slug}`;
    const mins = readingMinutes(article.body);
    return (
        <Link
            to={href}
            data-testid={`kolum-card-${article.slug}`}
            className="group flex h-full flex-col overflow-hidden rounded-3xl border border-peri-200 bg-white shadow-subtle transition-all duration-300 hover:-translate-y-1 hover:shadow-card-hover"
        >
            <div className="overflow-hidden">
                <img src={article.featured_image || DEFAULT_KOLUM_COVER} alt={article.image_alt || article.title} loading="lazy" onError={onImgError('dental')} className="aspect-[16/9] w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
            </div>
            <div className="flex flex-1 flex-col p-6">
                <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gold-700">
                    {article.category} · {article.language.toUpperCase()}
                </p>
                <h3 className={`mt-2.5 font-serif font-semibold leading-snug text-ink transition-colors group-hover:text-gold-700 ${featured ? 'text-2xl' : 'text-xl'}`}>
                    {article.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-ink-muted">{article.meta_description}</p>
                <div className="mt-auto flex items-center justify-between pt-5 text-xs text-ink-subtle">
                    <span>{article.author}</span>
                    <span>
                        {article.publish_date} · {mins} {t.kolum.minRead}
                    </span>
                </div>
            </div>
        </Link>
    );
}
